import { component } from 'vue-form-generator';
// import 'vue-form-generator/dist/vfg.css';

import customObjectData from '@/data/custom-object-schema';

export default {
  name: 'CustomObjectAddField',

  components: {
    VueFormGenerator: component,
  },

  data() {
    return {
      field: {
        model: customObjectData.newField.model,
        schema: customObjectData.newField.schema,
        formOptions: customObjectData.newField.formOptions,
      },
    };
  },

  methods: {
    createNewObject() {
      this.$router.push({ name: 'edit-custom-object' });
    },
  },
};
